export interface LoginInterface {
  username: string,
  password: string,
  sessionId?: string
}

export interface ResendOTPRequest{
  username: string;
  userRequestId: string;
}

export enum Message{
  OTP_REQUIRED = 'OTP_REQUIRED',
  OTP_SENT = 'OTP_SENT'
}

export interface VerifyOTPRequest{
  otp: string;
  userRequestId: string;
  sessionId?: any;
}

export interface UserSession {
  access_token: string;
  user_email: string;
  role: string;
  user_id: number;
  org_id: number;
  scope: string;
  roles: string[];
  expires_in: number;
}

export interface UserNumber {
  mobile: string;
  internationalNumber: string;
  nationalNumber: string;
  e164Number: string;
  countryCode: string;
  dialCode: string;
}

export interface UserTheme {
  id: number;
  name: string;
  colour: string;
  active: boolean;
  custom: boolean;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  pictureCid: string;
  picture: string;
  role: 'ADMIN' | 'USER' | string;
  number: UserNumber;
  roles: string[];
  createdDate: string;
  modifiedDate: string;
  theme: UserTheme;
  active: boolean;
  isTwoFactorEnabled: boolean;
  verificationStatus?: string;
  customer:{
    logo: string;
  }
}

export interface RegisterFormData {
  firstName: string;
  lastName?: string;
  companyName: string;
  email: string;
  countryCode: string;
  phone: string;
}

